import config from "config.json";

import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";


const SwaggerConfigured = () => <SwaggerUI url={config.rest_url.concat('/')} />;

export default SwaggerConfigured;
